import React, { useEffect, useRef } from 'react';

import application from 'application';

import BasicTextEditor from 'generics/components/basic-text-editor-slate';
import HelptapEditor from 'generics/components/basic-text-editor-slate/helpers';

import elementTypes from 'generics/components/basic-text-editor-slate/elements/types';

import {
  getEnabledElements
} from 'root/startup-view/campaigns/right-panel/editor-panel/editor/steps-editor/step-editor/body/content-editor/utilities';

function DescriptionEditor(props) {

  const mainReference = useRef(null);
  const editorReference = useRef(null);

  useEffect(function onContentChange() {

    const editor = editorReference.current;

    if (editor === null) {
      return;
    }

    HelptapEditor.setContent(editor, props.content);

  }, [props.content]);

  function renderEditor() {

    const mainAttributes = {
      ref: mainReference,
      className: 'content-editor-element-container hide-scrollbar'
    };

    const contentFieldAttributes = {
      placeholder: 'Write something, or type “/” for commands',
      placeholderOnEveryBlock: true,
      value: props.content,
      onChange(editorState) {
        props.onChange(editorState);
      },
      mediaUploadControls: {
        layout: 'columns',
        position: 'right bottom'
      },
      mediaUploader(file) {
        return props.mediaUploader(file);
      },
      overlayMenu: true,
      focus: false,
      adjustInputPosition: true,
      enabledElements: [
        ...getEnabledElements(),
        elementTypes.TOGGLE_LIST_ITEM
      ],
      readOnly: props.readOnly,
      // key: Date.now(),
      onFocus: props.onFocus,
      onBlur: props.onBlur,
      onEditorReady: props.onEditorReady,
      parentEntityId: props.parentEntityId,
      parentEntityType: 'LINKED_IN_POST',
      scrollingContainerSelector: props.scrollingContainerSelector,
      collaborativeEditing: props.collaborativeEditing,
      enableAdvancedOptions: true,
      displayLayouts: false,
      displayFavouriteBlocks: false,
      direction: application.domUtility.determineLangaugeDetails().dir
    };

    return <div {...mainAttributes}>
      <BasicTextEditor {...contentFieldAttributes} />
    </div>;

  }

  function renderMain() {

    return renderEditor();

  }

  return renderMain();

}

export function render(properties) {

  return <DescriptionEditor {...properties} />;

}

export default DescriptionEditor;